import classNames from 'classnames'
import React from 'react'

import Icon from '../icon'

import styles from './chevronIcon.module.scss'
import IconInline from './icon.inline.svg'
import IconWithBackground from './iconWithBG.inline.svg'

type ChevronDirection = 'top' | 'right' | 'bottom' | 'left'
type ChevronType = 'black' | 'white' | 'disabled'

interface ChevronIconProps {
  direction?: ChevronDirection
  type?: ChevronType
  className?: string
  isVisible?: boolean
  isIconWithBG?: boolean
}

const ChevronIcon = ({ direction = 'right', type = 'black', className, isVisible, isIconWithBG }: ChevronIconProps) => {
  return (
    <Icon
      iconSvg={isIconWithBG ? IconWithBackground : IconInline}
      className={classNames(
        styles.chevronIcon,
        type && `${styles[`chevronIcon__${type}`]}`,
        direction && `${styles[`chevronIcon__${direction}`]}`,
        isVisible && `${styles.chevronIcon__none}`,
        isIconWithBG && `${styles.chevronIcon__withBg}`,
        className,
      )}
    />
  )
}

export default ChevronIcon
